export const tags = [
  "jnct-flashcards",
  "jnct-flashcard",
  "jnct-flashcard-edit",
  "jnct-flashcards-edit-mode",
  "jnct-add-cards-modal",
  "jnct-transcript-modal",
] as const;
